var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56221 10.3142C7.58971 10.4975 7.52097 10.693 7.36287 10.8213C7.29927 10.878 7.22373 10.9229 7.14058 10.9536C7.05742 10.9842 6.96827 11 6.87825 11C6.78822 11 6.69907 10.9842 6.61592 10.9536C6.53276 10.9229 6.45722 10.878 6.39363 10.8213L3.63713 8.37109C3.56216 8.30594 3.50516 8.22626 3.47057 8.13828C3.43599 8.0503 3.42477 7.95641 3.43779 7.86393V4.73547L0.145116 0.989866C0.0334875 0.862485 -0.0168817 0.701007 0.005015 0.540717C0.0269117 0.380427 0.119294 0.234358 0.261975 0.134426C0.392582 0.0488823 0.536937 0 0.688166 0H10.3118C10.4631 0 10.6074 0.0488823 10.738 0.134426C10.8807 0.234358 10.9731 0.380427 10.995 0.540717C11.0169 0.701007 10.9665 0.862485 10.8549 0.989866L7.56221 4.73547V10.3142ZM2.09047 1.22206L4.81259 4.31386V7.68673L6.1874 8.90879V4.30775L8.90953 1.22206H2.09047Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.635ac2df45fa49a01cf387d12c21dacb.svg";
export { ForwardRef as ReactComponent };